// DecisionBar — approve / reject / (optional) request-revision buttons at
// the foot of a composer workbench. Presentational; the orchestrator owns
// the mutation and passes the `busy` lock so the reviewer cannot
// double-submit.

import { CheckCircle, ThumbsDown, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui';
import type { CompositionActions } from './composition-agent-config';

interface DecisionBarProps {
    actions: CompositionActions;
    busy: boolean;
    onApprove: () => void;
    onReject: () => void;
    onRequestRevision: () => void;
}

export default function DecisionBar({
    actions,
    busy,
    onApprove,
    onReject,
    onRequestRevision,
}: DecisionBarProps) {
    return (
        <div
            data-testid="workbench-decision-bar"
            className="flex items-center gap-2 pt-2 border-t border-[rgb(var(--color-divider))] flex-wrap"
        >
            <Button
                variant="primary"
                size="sm"
                data-testid="workbench-approve"
                onClick={onApprove}
                busy={busy}
                icon={<CheckCircle className="w-3.5 h-3.5" />}
            >
                {actions.approve.label}
            </Button>
            <Button
                variant="secondary"
                size="sm"
                data-testid="workbench-reject"
                onClick={onReject}
                disabled={busy}
                icon={<ThumbsDown className="w-3.5 h-3.5" />}
            >
                {actions.reject.label}
            </Button>
            {actions.requestRevision && (
                <Button
                    variant="secondary"
                    size="sm"
                    data-testid="workbench-request-revision"
                    onClick={onRequestRevision}
                    disabled={busy}
                    icon={<RotateCcw className="w-3.5 h-3.5" />}
                >
                    {actions.requestRevision.label}
                </Button>
            )}
        </div>
    );
}
